import { Http } from '@mygpt/app/http';

export type MSTokenInfo = {
  STTToken: string;
};

// 获取MS STT用Token
export const getMSTokenInfo = () => {
  const { get } = Http.use();
  return get<string>(`/v1/stt_token`).then((res) => ({
    STTToken: res.data,
  }));
};

export const getTTS = async (text: string, lang?: string, voice_actor?: string) => {
  const res = await fetch('https://tts.gbase.ai/tts', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'audio/wav',
    },
    body: JSON.stringify({
      text,
      ...(lang ? { lang } : {}), //中文 (zh) 英文 (en) 日语 (ja) 韩语 (ko)
      ...(voice_actor ? { voice_actor } : {}), // 语音角色
    }),
  });

  return res.blob();
};

export const getQuestionLang = async (text: string) => {
  const res = await fetch('https://tts.gbase.ai/detect-language', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      text,
    }),
  });

  const data = await res.json();
  return data.language;
};
